import { render, staticRenderFns } from "./ChooseStationForm.vue?vue&type=template&id=0bf5ecf5"
import script from "./ChooseStationForm.vue?vue&type=script&lang=js"
export * from "./ChooseStationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports